import React from "react";
import { Activity, ArrowDown, ArrowRight, Package, Users } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const transactionsData = [{
  id: "MVX-901",
  desc: "Venda Direta PDV",
  val: "+R$ 450,00"
}, {
  id: "MVX-902",
  desc: "Reposição Stock",
  val: "-R$ 1.200,00"
}, {
  id: "MVX-903",
  desc: "Royalties Rede",
  val: "+R$ 890,00"
}];
const suppliersData = [{
  id: "IND-01",
  name: "Indústria Têxtil",
  status: "Ativo"
}, {
  id: "LOG-02",
  name: "Transportadora",
  status: "Pendente"
}, {
  id: "MAT-03",
  name: "Matéria Prima",
  status: "Ativo"
}];
const inventoryData = [{
  id: "SET-01",
  item: "Calçado Sport",
  qtd: "150 un"
}, {
  id: "SET-02",
  item: "Acessório Couro",
  qtd: "42 un"
}, {
  id: "SET-03",
  item: "Meia Performance",
  qtd: "310 un"
}];
export default function ControloTotalDeDados() {
  return <section data-section-id="76803" id="ecossistema-de-gestão-linx" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <div className="bg-background h-[40rem] w-[40rem] rounded-full blur-3xl" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mb-16 text-center">
          <h2 className="text-[#FF006E] mb-4 text-sm font-semibold tracking-wider uppercase">
            Consultoria Especialista Linx
          </h2>
          <p className="mb-4 text-3xl font-bold tracking-tight sm:text-4xl md:text-[40px]">
            Ecossistema de Soluções Linx
          </p>
          <p className="text-[#A0A0A0] mx-auto max-w-2xl text-lg">
            Tecnologia de ponta para gestão de franquias e varejo, integrada para impulsionar sua lucratividade, otimizar processos e garantir escala operacional.
          </p>
        </div>

        <div className="flex flex-col items-center justify-center gap-6 lg:flex-row lg:items-stretch lg:gap-4 xl:gap-8">
          {}
          <Card className="border-[#E0E0E0]/10 bg-card/40 relative w-full max-w-md shadow-[0px_4px_10px_rgba(0,0,0,0.1)] backdrop-blur-xl lg:w-1/3 rounded-[10px]">
            <div className="bg-[#FF006E]/20 absolute top-0 left-0 h-1 w-full" />
            <CardHeader className="pb-4">
              <div className="bg-[#FF006E]/10 text-[#FF006E] mb-4 inline-flex h-12 w-12 items-center justify-center rounded-[10px]">
                <Activity strokeWidth={1.5} className="h-6 w-6" />
              </div>
              <CardTitle className="text-xl text-white">Linx Microvix</CardTitle>
              <CardDescription className="text-[#A0A0A0]">
                Gestão completa para lojas físicas e redes de franquias.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="border-[#E0E0E0]/10 rounded-[10px] border bg-black/20">
                <Table>
                  <TableHeader>
                    <TableRow className="border-[#E0E0E0]/10 hover:bg-transparent">
                      <TableHead className="text-[#A0A0A0] text-xs">ID</TableHead>
                      <TableHead className="text-[#A0A0A0] text-xs">Descrição</TableHead>
                      <TableHead className="text-[#A0A0A0] text-right text-xs">Valor</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {transactionsData.map((row, i) => <TableRow key={row.id} data-index={i} className="border-[#E0E0E0]/5 hover:bg-[#FF006E]/20 cursor-default transition-colors duration-200">
                        <TableCell className="font-mono text-xs text-white/70">{row.id}</TableCell>
                        <TableCell className="text-xs text-white/90">{row.desc}</TableCell>
                        <TableCell className={`text-right text-xs font-medium ${row.val.startsWith('+') ? 'text-[#FF006E]' : 'text-white'}`}>
                          {row.val}
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>

          {}
          <div className="flex items-center justify-center lg:py-0">
            <ArrowRight className="text-[#FF006E]/40 hidden h-8 w-8 shrink-0 lg:block" strokeWidth={1.5} />
            <ArrowDown className="text-[#FF006E]/40 block h-8 w-8 shrink-0 lg:hidden" strokeWidth={1.5} />
          </div>

          {}
          <Card className="border-[#E0E0E0]/10 bg-card/40 relative w-full max-w-md shadow-[0px_4px_10px_rgba(0,0,0,0.1)] backdrop-blur-xl lg:w-1/3 rounded-[10px]">
            <div className="bg-[#FF006E]/20 absolute top-0 left-0 h-1 w-full" />
            <CardHeader className="pb-4">
              <div className="bg-[#FF006E]/10 text-[#FF006E] mb-4 inline-flex h-12 w-12 items-center justify-center rounded-[10px]">
                <Users strokeWidth={1.5} className="h-6 w-6" />
              </div>
              <CardTitle className="text-xl text-white">e-Millennium</CardTitle>
              <CardDescription className="text-[#A0A0A0]">
                ERP robusto para atacado, indústria e omnichannel.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="border-[#E0E0E0]/10 rounded-[10px] border bg-black/20">
                <Table>
                  <TableHeader>
                    <TableRow className="border-[#E0E0E0]/10 hover:bg-transparent">
                      <TableHead className="text-[#A0A0A0] text-xs">ID</TableHead>
                      <TableHead className="text-[#A0A0A0] text-xs">Entidade</TableHead>
                      <TableHead className="text-[#A0A0A0] text-right text-xs">Estado</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {suppliersData.map((row, i) => <TableRow key={row.id} data-index={i} className="border-[#E0E0E0]/5 hover:bg-[#FF006E]/20 cursor-default transition-colors duration-200">
                        <TableCell className="font-mono text-xs text-white/70">{row.id}</TableCell>
                        <TableCell className="text-xs text-white/90">{row.name}</TableCell>
                        <TableCell className="text-right text-xs">
                          <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${row.status === 'Ativo' ? 'bg-[#FF006E]/20 text-[#FF006E]' : 'bg-white/10 text-white/70'}`}>
                            {row.status}
                          </span>
                        </TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>

          {}
          <div className="flex items-center justify-center lg:py-0">
            <ArrowRight className="text-[#FF006E]/40 hidden h-8 w-8 shrink-0 lg:block" strokeWidth={1.5} />
            <ArrowDown className="text-[#FF006E]/40 block h-8 w-8 shrink-0 lg:hidden" strokeWidth={1.5} />
          </div>

          {}
          <Card className="border-[#E0E0E0]/10 bg-card/40 relative w-full max-w-md shadow-[0px_4px_10px_rgba(0,0,0,0.1)] backdrop-blur-xl lg:w-1/3 rounded-[10px]">
            <div className="bg-[#FF006E]/20 absolute top-0 left-0 h-1 w-full" />
            <CardHeader className="pb-4">
              <div className="bg-[#FF006E]/10 text-[#FF006E] mb-4 inline-flex h-12 w-12 items-center justify-center rounded-[10px]">
                <Package strokeWidth={1.5} className="h-6 w-6" />
              </div>
              <CardTitle className="text-xl text-white">Seta Digital</CardTitle>
              <CardDescription className="text-[#A0A0A0]">
                Solução ágil para automação e gestão calçadista.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <div className="border-[#E0E0E0]/10 rounded-[10px] border bg-black/20">
                <Table>
                  <TableHeader>
                    <TableRow className="border-[#E0E0E0]/10 hover:bg-transparent">
                      <TableHead className="text-[#A0A0A0] text-xs">Ref</TableHead>
                      <TableHead className="text-[#A0A0A0] text-xs">Artigo</TableHead>
                      <TableHead className="text-[#A0A0A0] text-right text-xs">Stock</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {inventoryData.map((row, i) => <TableRow key={row.id} data-index={i} className="border-[#E0E0E0]/5 hover:bg-[#FF006E]/20 cursor-default transition-colors duration-200">
                        <TableCell className="font-mono text-xs text-white/70">{row.id}</TableCell>
                        <TableCell className="text-xs text-white/90">{row.item}</TableCell>
                        <TableCell className="text-right text-xs font-medium text-white/90">{row.qtd}</TableCell>
                      </TableRow>)}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}